import React from 'react';
import { NavLink } from 'react-router-dom';
import { object, array } from 'prop-types';

const propTypes = {
  glossary: object.isRequired,
  keys: array.isRequired,
};
const defaultProps = {
  glossary: {},
  keys: [],
};

const FaqGlossaryLine = ({ glossary, keys }) =>
  keys.map((id) => {
    if (!glossary[id].length) {
      return null;
    }
    return (
      <div className="faq-glossary-line" key={id} id={`FaqGlossaryLine_${id}`}>
        <div className="faq-glossary-line-title">{id}</div>
        <div className="faq-glossary-line-items">
          {glossary[id].map(([item]) => (
            <NavLink
              className="faq-glossary-line-item"
              activeClassName="active"
              to={`/${item.path}`}
              key={item.path}
              exact
            >
              {item.title}
            </NavLink>
          ))}
        </div>
      </div>
    );
  });

FaqGlossaryLine.propTypes = propTypes;
FaqGlossaryLine.defaultProps = defaultProps;

export default FaqGlossaryLine;
